/* RESPONSIBLE TEAM: team-ai-insights */
import { PERFORMANCE_PRO_ID } from 'embercom/lib/billing';
import type Product from 'embercom/models/product';

const TWENTY_FOUR_HOURS_MS = 24 * 60 * 60 * 1000;

export function isRecentAiInsightsPurchase(products: Product[]): boolean {
  let performanceProProduct = products.find((product) => product.id === PERFORMANCE_PRO_ID);
  if (!performanceProProduct) {
    return false;
  }

  let now = Date.now();

  if (performanceProProduct.activeTrialStartedAt) {
    let trialStartedAt = new Date(performanceProProduct.activeTrialStartedAt).getTime();
    if (now - trialStartedAt < TWENTY_FOUR_HOURS_MS) {
      return true;
    }
  }

  let activatedAt = performanceProProduct.activePlan?.activatedAt;
  if (activatedAt) {
    let activatedAtMs = new Date(activatedAt).getTime();
    if (now - activatedAtMs < TWENTY_FOUR_HOURS_MS) {
      return true;
    }
  }

  return false;
}
